import * as React from "react";
import { Toast } from "react-bootstrap";
import { connect } from "react-redux";
import FeedbackTypeEnum from "../../../constants/FeedbackTypeEnum";
import IStore from "../../../models/IStore";
import { ReduxProps } from "../../../models/ReduxProps";
import IToast from "../../../stores/toasts/models/IToast";
import ToastsAction from "../../../stores/toasts/ToastsAction";

interface IProps {
    readonly item: IToast;
}
interface IState {
    show: boolean;
    showDetails: boolean;
}
interface IStateToProps {}

const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({});

class ToastCard extends React.Component<IProps & IStateToProps & ReduxProps<any>, IState> {
    constructor(props: IProps & IStateToProps & ReduxProps<any>) {
        super(props);
        this.state = {
            show: true,
            showDetails: false,
        } as IState;
    }

    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private setShow = (show: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({ show });
        }
    };

    private toggleShow = () => {
        this.setShow(!this.state.show);
        this.props.dispatch(ToastsAction.removeById(this.props.item.id));
    };

    private getVariant = (type: FeedbackTypeEnum) => {
        switch (type) {
            case FeedbackTypeEnum.Success:
                return "bg-success";
            case FeedbackTypeEnum.Warning:
                return "bg-warning";
            case FeedbackTypeEnum.Error:
                return "bg-danger";
        }
    };

    private getTitle = (type: FeedbackTypeEnum) => {
        switch (type) {
            case FeedbackTypeEnum.Success:
                return "Successo";
            case FeedbackTypeEnum.Warning:
                return "global_error_warning";
            case FeedbackTypeEnum.Error:
                return "Si è verificato un errore";
        }
    };

    public render(): JSX.Element {
        const { item } = this.props;

        return (
            <Toast show={this.state.show} onClose={this.toggleShow} delay={5000} autohide>
                <Toast.Header className={this.getVariant(item.type)}>
                    <strong className="mr-auto">{this.getTitle(item.type)}</strong>
                </Toast.Header>
                <Toast.Body>{item.message}</Toast.Body>
            </Toast>
        );
    }
}

export { ToastCard as Unconnected };
export default connect(mapStateToProps)(ToastCard);
